import { render } from "./DialogServiceHost.vue?vue&type=template&id=b258c244&scoped=true"
import script from "./DialogServiceHost.vue?vue&type=script&lang=js"
export * from "./DialogServiceHost.vue?vue&type=script&lang=js"

import "./DialogServiceHost.vue?vue&type=style&index=0&id=b258c244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b258c244"]])

export default __exports__